import * as React from 'react';

import { MSTenantEntity } from 'jamespot-user-api';

import { useTenants } from '../hooks';
import { JRCLoader } from '../../JRCLoader/JRCLoader';
import { LoaderWrapper } from './MSGraphGroups';
import { TenantEntityItem } from './components/TenantEntityItem';
import { DriveIsEmpty } from '../components/DriveIsEmpty';
import { JDriveApi } from 'jamespot-user-api/lib/src/apis/drive/drive';

export const MSGraphTenants = ({
    initialFolderColor,
    onClick,
    onError,
    handlers,
    id,
}: {
    initialFolderColor?: string;
    onClick: (entity: MSTenantEntity) => void;
    onError?: (code: string) => void;
    handlers: {
        drive: Pick<JDriveApi, 'tenants'>;
    };
    id: string;
}) => {
    const { loading, entities, error } = useTenants({ handlers, id });

    React.useEffect(() => {
        if (error !== undefined && Array.isArray(error.messages)) {
            error.messages.forEach((message: { msg: string }) => {
                if (onError) {
                    onError(message.msg);
                }
            });
            if (error.errorMsg) {
                if (onError) {
                    onError(error.errorMsg);
                }
            }
        }
    }, [error, onError]);

    if (loading) {
        return (
            <LoaderWrapper>
                <JRCLoader size={'l'} />
            </LoaderWrapper>
        );
    }

    if (!loading && entities.length === 0) {
        return <DriveIsEmpty />;
    }

    return (
        <>
            {entities.map((entity) => (
                <TenantEntityItem
                    key={entity.title}
                    entity={entity}
                    initialFolderColor={initialFolderColor}
                    onClick={() => onClick(entity)}
                />
            ))}
        </>
    );
};
